import apiClient from "@/app/api/client";
import { organizationTypeEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateOrganizationTypeRequest,
	MessageData,
	OrganizationType,
	PaginatedResponse,
	PaginationParams,
	SuccessResponse,
	UpdateOrganizationTypeRequest,
} from "../types";

export const organizationTypeService = {
	async list(params?: PaginationParams): Promise<PaginatedResponse<OrganizationType>> {
		const response = await apiClient.get<PaginatedResponse<OrganizationType>>(
			organizationTypeEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<OrganizationType> {
		const url = replaceParams(organizationTypeEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<OrganizationType>>(url);
		return response.data.data;
	},

	async create(data: CreateOrganizationTypeRequest): Promise<OrganizationType> {
		const response = await apiClient.post<SuccessResponse<OrganizationType>>(
			organizationTypeEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateOrganizationTypeRequest): Promise<OrganizationType> {
		const url = replaceParams(organizationTypeEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<OrganizationType>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(organizationTypeEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},
};
